import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';

@Component({
  selector: 'app-login-guide',
  templateUrl: './login-guide.component.html',
  styleUrls: ['./login-guide.component.css', '../common/css/index.css'],
})
export class LoginGuideComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  email: string;
  constructor(private router: Router) {
    super();
  }
  ngOnInit(): void {
    // 画面遷移前にセットされたemailを取得
    this.email = sessionStorage.getItem(sessionStorageKey.loginGuideEmail);
    // ない場合は異常なルートでアクセスされているため表示させない
    if (!this.email) {
      history.back();
    }
  }

  clickLoginButton() {
    // ログインボタンを押下したらパラメータを保持したままログイン画面へ遷移
    this.router.navigate(['/login'], {
      queryParamsHandling: 'preserve',
    });
  }
}
